import React, { useEffect, useState, useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { useParams, Link } from "react-router-dom";
import Button from "@mui/material/Button";
import PrintIcon from "@mui/icons-material/Print";
import SaveIcon from "@mui/icons-material/Save";
import EditIcon from "@mui/icons-material/Edit";
import api from "../../hooks/apiClient";
import { useSnackbar } from "notistack";
import { CircularProgress } from "@mui/material";
import OrderDetailsTable from "./Table";
import A4Barcode from "./LaamBarcodes";
import ThermalBarcode from "./components/BarcodeLabels50";
const OrderDetail = ({ authToken }) => {
  const { id } = useParams();
  const printRef = useRef();
  const printRefBarcode = useRef();
  const { enqueueSnackbar } = useSnackbar();
  const [orderData, setOrderData] = useState(null);
  const [orderDetails, setOrderDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [forceOpen, setForceOpen] = useState(false);
  const [barcodePage, setBarCodePage] = useState(false);
  const [thermalBarcodePage, setThermalBarcodePage] = useState(false);

  const handlePrint = () => {
    setForceOpen(true);
  };
  const handlePrintPage = useReactToPrint({
    content: () => printRef.current,
    documentTitle: "Orders",

    onAfterPrint: () => {
      setForceOpen(false);
    },
    pageStyle: `
      @page {
        size: A4;
        margin: 2mm;
      }
      @media print {
        .print-product-wrapper {
          break-inside: avoid;
          page-break-inside: avoid;
        }
        /* Optional: Break only after a product block if needed */
        .print-product-wrapper:not(:last-child) {
          page-break-after: auto;
        }
    
        body {
          -webkit-print-color-adjust: exact;
          font-size: 8pt;
        }
        .no-print {
          display: none !important;
        }
        @page :first {
          margin-top: 5mm;
        }
      }
      body:after {
        content: "VELVOUR";
        position: fixed;
        opacity: 0.04;
        font-size: 80px;
        transform: rotate(-45deg);
        top: 50%;
        left: 30%;
        z-index: 9999;
      }

    `,
  });
  async function handelBarcodeShow(ths = false) {
    setBarCodePage((prevShow) => !prevShow);
    setThermalBarcodePage(ths);
  }

  const barcodePagePrint = useReactToPrint({
    content: () => printRefBarcode.current,
    documentTitle: "Barcodes",

    onAfterPrint: () => {
      setBarCodePage(false);
    },
  });
  const getTheOrder = async () => {
    setLoading(true);
    try {
      const response = await api.get(`orders/laam/find/${id}`);
      setOrderData(response.data);
      setOrderDetails(response.data.groupedDetails);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching order data:", error);
      setLoading(false);
    }
  };
  useEffect(() => {
    getTheOrder();
  }, [id]);

  const handleDispatchOrder = async (dispatched) => {
    const confirmed = window.confirm(
      dispatched
        ? "Are you sure you want to Submit this order And dispatch?"
        : "Are you sure you want to Open this order again?"
    );
    if (confirmed) {
      try {
        const response = await api.put(`orders/laam/${orderData.id}`, {
          store_id: orderData.store_id,
          isDispatched: dispatched,
          status: dispatched ? "Dispatched" : "Opend again",
        });

        enqueueSnackbar(response.data, {
          variant: "success",
        });

        getTheOrder();
      } catch (error) {
        console.error("Error fetching file:", error);
        enqueueSnackbar("Order Can not be dispached see logs", {
          variant: "error",
        });
      }
    }
  };

  const handleDownload = () => {};

  const deleteOrderProduct = async (pid) => {
    const confirmed = window.confirm(
      "Are you sure you want to delete this Product?"
    );
    try {
      if (confirmed) {
        const response = await api.delete(`orders/laam/${orderData.id}`, {
          params: {
            product_id: pid,
          },
        });
        enqueueSnackbar("Ok product Deleted successfully...", {
          variant: "warning",
        });

        getTheOrder();
      } else {
      }
    } catch (error) {
      console.error("Error delet order data:", error);
    }
  };
  if (loading) {
    return (
      <div className="container">
        <CircularProgress />
      </div>
    );
  }
  if (!orderData) return <div>No Order Found</div>;
  if (barcodePage) {
    return (
      <div className="container">
        <div className="shadow p-1 bg-body rounded floating-button-top">
          <button
            className="btn btn-sm btn-info no-print "
            onClick={handelBarcodeShow}
          >
            Show Order
          </button>{" "}
          <button
            className="ms-2 btn btn-sm btn-success"
            onClick={barcodePagePrint}
          >
            Print Barcodes
          </button>
        </div>

        <div ref={printRefBarcode}>
          {orderDetails.length > 0 && thermalBarcodePage ? (
            <ThermalBarcode data={orderDetails} />
          ) : (
            <A4Barcode data={orderDetails} />
          )}
        </div>
      </div>
    );
  }
  return (
    <div>
      {forceOpen ? (
        <Button
          variant="contained"
          startIcon={<PrintIcon />}
          onClick={handlePrintPage}
          sx={{ mb: 1, mr: 1, mt: 1 }}
        >
          Print Pages
        </Button>
      ) : (
        <Button
          variant="contained"
          startIcon={<PrintIcon />}
          onClick={handlePrint}
          sx={{ mb: 1, mr: 1, mt: 1 }}
        >
          Print Order
        </Button>
      )}
      <Button
        variant="contained"
        startIcon={<PrintIcon />}
        onClick={() => handelBarcodeShow(true)}
        sx={{ mb: 1, mr: 1, mt: 1 }}
      >
        Thermal BarCodes
      </Button>
      <Button
        variant="contained"
        startIcon={<PrintIcon />}
        onClick={() => handelBarcodeShow(false)}
        sx={{ mb: 1, mr: 1, mt: 1 }}
      >
        A4 BarCodes
      </Button>
      <Button
        variant="contained"
        startIcon={orderData.isDispatched ? <EditIcon /> : <SaveIcon />}
        onClick={() => handleDispatchOrder(!orderData.isDispatched)}
        sx={{ mb: 1, mr: 1, mt: 1 }}
      >
        {orderData.isDispatched ? "Open Dispatch" : "Send Laam"}
      </Button>
      <hr />
      <div ref={printRef}>
        {orderDetails.length > 0 && (
          <OrderDetailsTable
            orderDetails={orderDetails}
            order={orderData}
            forceOpen={forceOpen}
            deleteProduct={deleteOrderProduct}
            printing={forceOpen}
          />
        )}
      </div>
    </div>
  );
};

export default OrderDetail;
